// extracted by mini-css-extract-plugin
module.exports = {"root":"root--V-ktJ","likeItem":"likeItem--cQ0qX","downloadButton":"downloadButton--hV1Ml"};